"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * Returns user full name
   * @param {string} firstName - first name
   * @param {string} lastName - last name
   * @returns {string} - full name
   */
  getFullName(firstName, lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }

};
exports.default = _default;